import { render } from "./VisitValues.vue?vue&type=template&id=dd635cb6"
import script from "./VisitValues.vue?vue&type=script&lang=js"
export * from "./VisitValues.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__